import React from 'react';
import PropTypes from 'prop-types';
import { Container, Header, ContentArea } from './styles';

const DropDown = ({ isOpen, setIsOpen, headerComponent, children, dataPanel, tooltip = '', width = '100%' }) => {
  return (
    <Container data-panel={`dropDown-container-${dataPanel}`} width={width}>
      <Header data-panel={`dropDown-header-${dataPanel}`} onClick={setIsOpen} title={tooltip}>
        {headerComponent}
      </Header>
      <ContentArea data-panel={`dropDown-contentArea-${dataPanel}`} isOpen={isOpen}>
        {children}
      </ContentArea>
    </Container>
  );
};

DropDown.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  headerComponent: PropTypes.element.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.number]).isRequired,
  dataPanel: PropTypes.string.isRequired
};

export default DropDown;
